import ContentBox from 'components/ContentBox'
import Header from 'components/home/Header'
import React, { useEffect, useState } from 'react'
import MapComponent from './Map'

export default function Contatos() {
    const [position, setPosition] = useState([-19.852299394288814, -43.96476940798442]);
    const flyToPosition = [-19.852299394288814, -43.96476940798442];
    let leafletContainer = null;

    useEffect(() => {
        document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
        // leafletContainer = document.querySelector('.leaflet-container');
        // if (leafletContainer) { leafletContainer.style.opacity = 0.3; }


        // setTimeout(function () {
        //     leafletContainer = document.querySelector('.leaflet-container');
        //     if (leafletContainer) {
        //         leafletContainer.style.transition = 'opacity 1s, visibility 1s';
        //         leafletContainer.style.opacity = 1;
        //     }
        // }, 1000);

        setTimeout(function () {
            const buttonFly = document.getElementById('buttonFly');
            if (buttonFly)
                buttonFly.click();
        }, 1000);

    }, []);

    return (<>
        <section className="content">
            <Header>
                <h5 style={{ marginLeft: '8px', marginBottom: '' }}> <i className='zmdi zmdi-comments'></i> FALE CONOSCO  </h5>
            </Header>
            <div className='container-fluid' style={{ marginBottom: '-20px' }}>
                <div className="row clearfix">
                    <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12" style={{ marginBottom: '-30px' }}>
                        <a href='https://maps.app.goo.gl/d2wt4ZifDvrFrvq39' target='_blank' className='text-decoration-none'>
                            <div class="card bg-green">
                                <div class="body text-white">
                                    <h4><i className='zmdi zmdi-pin' style={{ fontSize: '30px' }}></i> ENDEREÇO </h4>
                                    <i className='zmdi zmdi-mouse blink_me small'></i>
                                    <span className='m-l-30'>  ALAMEDA DAS ACÁCIAS, 70 CEP 31.275-150 - SÃO LUIZ  | BELO HORIZONTE - MG </span>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-3 col-sm-6 col-md-6 col-xs-12" style={{ marginBottom: '-30px' }}>
                        <div class="card bg-blue-grey">
                            <a href='tel:+553134489475' className='text-decoration-none'>
                                <div class="body text-white">
                                    <h4><i className='zmdi zmdi-phone' style={{ fontSize: '30px' }}></i> TELEFONE </h4>
                                    <span className='m-l-30'> +55 (31) 3448-9650 <br /></span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 col-md-6 col-xs-12" style={{ marginBottom: '-30px' }}>
                        <a href='mailto:leirobin@fjp.mg.gov.br' className='text-decoration-none'>
                            <div class="card bg-blue-grey">
                                <div class="body text-white">
                                    <h4><i className='zmdi zmdi-email' style={{ fontSize: '30px' }}></i>  EMAIL </h4>
                                    <span className='m-l-30'>leirobin@fjp.mg.gov.br</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>



        <section className='content'  >
            <div className='container-fluid'>
                <div className="row clearfix">
                    <div className='col-12'>
                        <div className='card'>
                            <div className='body'>
                                <MapComponent position={position} zoom={14} flyToPosition={flyToPosition} flyToZoom={17} ></MapComponent>
                                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3752.7083759819407!2d-43.964752!3d-19.8522885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa6904249364cdf%3A0x15329688191f0e5a!2sAlameda%20das%20Ac%C3%A1cias%2C%2070%20-%20S%C3%A3o%20Luiz%2C%20Belo%20Horizonte%20-%20MG%2C%2031275-150!5e0!3m2!1spt-BR!2sbr!4v1716555855439!5m2!1spt-BR!2sbr" width="100%" height="600" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className='row'></div>
    </>
    )
}